import React from "react";
import { AgoraVideoPlayer } from "agora-rtc-react";
import {
  CameraFill,
  CameraVideoOffFill,
  MicFill,
  MicMuteFill,
} from "react-bootstrap-icons";
import { classNames } from "../../functions/propsComponent";

export default function VideoPlayerThum(props) {
  const {
    videoTrack,
    isVideoMute,
    isMicMute,
    title,
    uid,
    isSpeak,
    shareScreen = false,
  } = props;
  console.log(
    "videoPlayer",
    isVideoMute || videoTrack,
    isVideoMute,
    videoTrack
  );
  return (
    <div
      id={"vidComp-" + uid}
      className={classNames(
        isSpeak ? "bg-green-500" : "bg-secondary-800",
        " relative  p-1 overflow-hidden border rounded-lg",
        isVideoMute ? "border-secondary-800" : "border-secondary-300"
      )}
      style={{ height: "100%" }}
    >
      {isVideoMute || videoTrack == null ? (
        <div className="aspect-video h-full bg-secondary-800 "></div>
      ) : (
        <AgoraVideoPlayer
          className={classNames(
            "h-full mx-auto aspect-[9/16] md:aspect-video bg-secondary-800"
          )}
          style={{ height: "100%", width: "100%" }}
          // className="vid"
          videoTrack={videoTrack}
        />
      )}
      {shareScreen == false && (
        <>
          {isVideoMute == true && (
            <div className="absolute top-0 left-0 text-white gap-2 h-full w-full flex justify-center items-center">
              {isMicMute == true ? (
                <MicMuteFill size={24} className="text-gray-500" />
              ) : (
                <MicFill size={24} />
              )}
              <CameraVideoOffFill size={24} className="text-gray-500" />
            </div>
          )}
        </>
      )}
    </div>
  );
}
